import React from "react";
import { Card, CardContent, Typography, Box, IconButton } from "@mui/material";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

export default function CustomCardWithBorder({
  children,
  onClick,
  hovershadowEffect,
  height,
  textAlign,
  padding,
  cursor,
  py,
  boxShadow,

  ...props
}) {
  return (
    <>
      <Card
        onClick={onClick}
        sx={{
          borderRadius: "16px",

          cursor: cursor ? "pointer" : null,
          padding: padding ? padding : "20px",
          height: height ? height : null,
          border: "1px solid #EAE3E3",
           py: py ? py : 2,
          boxShadow: boxShadow && "0px 0px 4px rgba(0, 0, 0, 0.1)", // 👈 Drop shadow
          // transition:boxShadow && "box-shadow 0.2s ease",

          "&:hover": hovershadowEffect
            ? { boxShadow: "0px 4px 12px rgba(0,0,0,0.3)" }
            : "",
         
        }}
        {...props}
      >
        {children}
      </Card>
    </>
  );
}
